import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import Carousel from 'components/Carousel/Carousel';

const quotes = [
  {
    source: 'PRESS.NEWS.FAST_COMPANY.SOURCE',
    text: 'PRESS.NEWS.FAST_COMPANY.TEXT',
    href: 'https://www.fastcompany.com/most-innovative-companies/2019/sectors/latin-america',
  },
  {
    source: 'PRESS.NEWS.NY_TIMES.SOURCE',
    text: 'PRESS.NEWS.NY_TIMES.TEXT',
    href: 'https://www.nytimes.com/2015/06/03/business/dealbook/nubank-raises-30-million-to-challenge-banking-in-brazil.html',
  },
  {
    source: 'PRESS.NEWS.AGENCIA_EFE.SOURCE',
    text: 'PRESS.NEWS.AGENCIA_EFE.TEXT',
    href: 'https://www.efe.com/efe/america/comunicados/nubank-llega-a-mexico-para-brindar-servicios-financieros-digitales-trayendo-simplicidad-y-acceso-la-industria-financiera-mexicana/20004010-MULTIMEDIAE_3970427',
  },
  {
    source: 'PRESS.NEWS.EXAME.SOURCE',
    text: 'PRESS.NEWS.EXAME.TEXT',
    href: 'https://exame.abril.com.br/negocios/nubank-agora-vale-tanto-quanto-a-renner-faz-sentido/',
  },
  {
    source: 'PRESS.NEWS.TECH_CRUNCH.SOURCE',
    text: 'PRESS.NEWS.TECH_CRUNCH.TEXT',
    href: 'https://techcrunch.com/2019/07/26/fintech-decacorn-nubank-raises-400m-led-by-tcv/',
  },
  {
    source: 'PRESS.NEWS.ESTADAO.SOURCE',
    text: 'PRESS.NEWS.ESTADAO.TEXT',
    href: 'https://link.estadao.com.br/noticias/inovacao,nao-olhamos-para-fintechs-mas-o-nubank-e-uma-grande-marca-diz-novo-investidor,70002940796',
  },
  {
    source: 'PRESS.NEWS.BUSINESS_INSIDER.SOURCE',
    text: 'PRESS.NEWS.BUSINESS_INSIDER.TEXT',
    href: 'https://www.businessinsider.com/neobank-becomes-most-valuable-neobank-after-mega-funding-round-2019-7',
  },
];

class SectionPress extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
    };
  }

  handleChangeCarouselStep = step => {
    this.setState(() => ({
      currentStep: step,
    }));
  };

  render() {
    const { currentStep } = this.state;

    return (
      <Section minHeight="70vh">
        <Block blockWidth="100%" textAlign="center" justifyContent="center">
          <Carousel
            currentStep={currentStep}
            onStepChanged={this.handleChangeCarouselStep}
          >
            {quotes.map(quote => (
              <div key={quote.text}>
                <FormattedMessage id={quote.text}>
                  {([txt]) => (
                    <Typography
                      variant="title"
                      tag="h2"
                      color="black"
                      gutterBottom={1}
                    >
                      {`"${txt}"`}
                    </Typography>
                  )}
                </FormattedMessage>

                <Link
                  color="primary"
                  variant="action"
                  href={quote.href}
                  intlKey={quote.source}
                />
              </div>
            ))}
          </Carousel>
        </Block>
      </Section>
    );
  }
}

export default SectionPress;
